import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
	{
		path: '/',
		name: 'Layout',
		component: () => import('../views/Layout.vue'),
		redirect: '/index',
		meta: {
			title: '主页'
		},
		children: [
			{
				path: '/index',
				component: () => import('../views/index/index.vue'),
				name: 'Index',
				meta: {
					title: '工作台'
				},
				children: null
			},
			{
				path: '/kc_index',
				component: () => import('../views/index/kc_index.vue'),
				name: 'KcIndex',
				meta: {
					title: '工作台'
				},
				children: null
			},
			{
				path: '/setting',
				component: () => import('../views/system/setting/index.vue'),
				name: 'Setting',
				meta: {
					title: '系统设置'
				},
				children: null
			},
			{
				path: '/admin_role',
				component: () => import('../views/system/admin_role/index.vue'),
				name: 'AdminRole',
				meta: {
					title: '角色管理'
				},
				children: null
			},
			{
				path: '/admin',
				component: () => import('../views/system/admin/index.vue'),
				name: 'Admin',
				meta: {
					title: '人员列表'
				},
				children: null
			},
			{
				path: '/operation',
				component: () => import('../views/system/operation/index.vue'),
				name: 'Operation',
				meta: {
					title: '权限管理'
				},
				children: null
			},
			{
				path: '/operation_log',
				component: () => import('../views/system/operation_log/index.vue'),
				name: 'OperationLog',
				meta: {
					title: '系统日志'
				},
				children: null
			},
			{
				path: '/images',
				component: () => import('../views/system/images/index.vue'),
				name: 'Images',
				meta: {
					title: '图片管理'
				},
				children: null
			},
			{
				path: '/article_type',
				component: () => import('../views/operate/article_type/index.vue'),
				name: 'ArticleType',
				meta: {
					title: '文章类型'
				},
				children: null
			},
			{
				path: '/article',
				component: () => import('../views/operate/article/index.vue'),
				name: 'Article',
				meta: {
					title: '文章管理'
				},
				children: null
			},
			{
				path: '/article_edit',
				component: () => import('../views/operate/article/edit.vue'),
				name: 'ArticleEdit',
				meta: {
					title: '编辑文章'
				},
				children: null
			},
			{
				path: '/menus',
				component: () => import('../views/operate/menus/index.vue'),
				name: 'Menus',
				meta: {
					title: '菜单管理'
				},
				children: null
			},
			{
				path: '/banners',
				component: () => import('../views/operate/banners/index.vue'),
				name: 'Banners',
				meta: {
					title: '广告管理'
				},
				children: null
			},
			{
				path: '/position',
				component: () => import('../views/operate/position/index.vue'),
				name: 'Position',
				meta: {
					title: '广告位管理'
				},
				children: null
			},
			{
				path: '/notice',
				component: () => import('../views/operate/notice/index.vue'),
				name: 'Notice',
				meta: {
					title: '公告管理'
				},
				children: null
			},
			{
				path: '/goods',
				component: () => import('../views/goods/goods/index.vue'),
				name: 'Goods',
				meta: {
					title: '商品管理'
				},
				children: null
			},
			{
				path: '/goods_edit',
				component: () => import('../views/goods/goods/edit.vue'),
				name: 'GoodsEdit',
				meta: {
					title: '商品编辑'
				},
				children: null
			},
			{
				path: '/goods_cat',
				component: () => import('../views/goods/goods_cat/index.vue'),
				name: 'GoodsCat',
				meta: {
					title: '商品分类'
				},
				children: null
			},
			{
				path: '/goods_spec',
				component: () => import('../views/goods/goods_spec/index.vue'),
				name: 'GoodsSpec',
				meta: {
					title: '商品规格'
				},
				children: null
			},
			{
				path: '/user',
				component: () => import('../views/user/user/index.vue'),
				name: 'User',
				meta: {
					title: '会员列表'
				},
				children: null
			},
			{
				path: '/user_detail',
				component: () => import('../views/user/user/detail.vue'),
				name: 'UserDetail',
				meta: {
					title: '会员详情'
				},
				children: null
			},
			{
				path: '/user_grade',
				component: () => import('../views/user/user_grade/index.vue'),
				name: 'UserGrade',
				meta: {
					title: '会员等级'
				},
				children: null
			},
			{
				path: '/promotion',
				component: () => import('../views/promotion/promotion/index.vue'),
				name: 'Promotion',
				meta: {
					title: '促销管理'
				},
				children: null
			},
			{
				path: '/promotion_goods',
				component: () => import('../views/promotion/promotion/list.vue'),
				name: 'PromotionGoods',
				meta: {
					title: '促销商品'
				},
				children: null
			},
			{
				path: '/order',
				component: () => import('../views/order/order/index.vue'),
				name: 'Order',
				meta: {
					title: '订单管理'
				},
				children: null
			},
			{
				path: '/coupon',
				component: () => import('../views/promotion/coupon/index.vue'),
				name: 'Coupon',
				meta: {
					title: '优惠券'
				},
				children: null
			},
			{
				path: '/label',
				component: () => import('../views/operate/label/index.vue'),
				name: 'Label',
				meta: {
					title: '标签管理'
				},
				children: null
			},
			{
				path: '/tijian',
				component: () => import('../views/goods/tijian/index.vue'),
				name: 'tijian',
				meta: {
					title: '体检产品'
				},
				children: null
			},
			{
				path: '/tijian_edit',
				component: () => import('../views/goods/tijian/edit.vue'),
				name: 'TijianEdit',
				meta: {
					title: '商品编辑'
				},
				children: null
			},
			{
				path: '/store',
				component: () => import('../views/goods/store/index.vue'),
				name: 'Store',
				meta: {
					title: '机构管理'
				},
				children: null
			},
			{
				path: '/store_list',
				component: () => import('../views/goods/store/list.vue'),
				name: 'StoreList',
				meta: {
					title: '体检套餐'
				},
				children: null
			},
			// {
			//   path: '/logistics',
			//   component: () => import('../views/operate/logistics/index.vue'),
			//   name: 'Logistics',
			//   meta: {
			// 	title: '物流公司'
			//   },
			//   children: null
			// },
			{
				path: '/kc_xsgl',
				component: () => import('../views/kc/xsgl/index.vue'),
				name: 'Xsgl',
				meta: {
					title: '销售管理'
				},
				children: null
			},
			{
				path: '/xsgl_edit',
				component: () => import('../views/kc/xsgl/edit.vue'),
				name: 'XsglEdit',
				meta: {
					title: '销售管理编辑'
				},
				children: null
			},
			{
				path: '/kc_kcgl',
				component: () => import('../views/kc/kcgl/index.vue'),
				name: 'Kcgl',
				meta: {
					title: '库存管理'
				},
				children: null
			},
			{
				path: '/kcgl_edit',
				component: () => import('../views/kc/kcgl/edit.vue'),
				name: 'kcglEdit',
				meta: {
					title: '库存管理编辑'
				},
				children: null
			},
			{
				path: '/kcgl_log',
				component: () => import('../views/kc/kcgl/log.vue'),
				name: 'kcglLog',
				meta: {
					title: '库存日志'
				},
				children: null
			},
			{
				path: '/kcgl_view',
				component: () => import('../views/kc/kcgl/view.vue'),
				name: 'kcglView',
				meta: {
					title: '库存明细'
				},
				children: null
			},
			{
				path: '/kc_cgmx',
				component: () => import('../views/kc/cgmx/index.vue'),
				name: 'Cgmx',
				meta: {
					title: '采购明细'
				},
				children: null
			},
			{
				path: '/cgmx_edit',
				component: () => import('../views/kc/cgmx/edit.vue'),
				name: 'CgmxEdit',
				meta: {
					title: '采购明细编辑'
				},
				children: null
			},
			{
				path: '/cgmx_view',
				component: () => import('../views/kc/cgmx/view.vue'),
				name: 'CgmxView',
				meta: {
					title: '采购明细'
				},
				children: null
			},
			{
				path: '/category',
				component: () => import('../views/kc/category/index.vue'),
				name: 'Category',
				meta: {
					title: '产品分类'
				},
				children: null
			},
			{
				path: '/dc_list',
				component: () => import('../views/dc/list/index.vue'),
				name: 'Dclist',
				meta: {
					title: '设备列表'
				},
				children: null
			},
			{
				path: '/dc_ewm',
				component: () => import('../views/dc/ewm/index.vue'),
				name: 'Ewm',
				meta: {
					title: '二维码'
				},
				children: null
			},
			{
				path: '/tjjg',
				component: () => import('../views/tjjg/tjjg/index.vue'),
				name: 'Tjjg',
				meta: {
					title: '体检机构'
				},
				children: null
			},
			{
				path: '/tjyy',
				component: () => import('../views/tjjg/tjyy/index.vue'),
				name: 'Tjyy',
				meta: {
					title: '体检预约'
				},
				children: null
			},
			{
				path: '/sbyy',
				component: () => import('../views/tjjg/sbyy/index.vue'),
				name: 'Sbyy',
				meta: {
					title: '设备预约'
				},
				children: null
			},
			{
				path: '/hy',
				component: () => import('../views/operate/hy/index.vue'),
				name: 'Hy',
				meta: {
					title: '会议管理'
				},
				children: null
			},
		],
	},
	{
		path: '/login',
		name: 'Login',
		component: () => import('../views/login/login.vue')
	},
]

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes
})

// 全局前置守卫
router.beforeEach((to, from, next) => {
	// 获取token
	let token = Vue.prototype.VueCookies.get("token")
	if (token) { // 已登录
		// 防止重复登录
		if (to.path === '/login') {
			// Vue.prototype.$message.error('请不要重复登录');
			return next({ path: from.path ? from.path : '/' })
		}
		//其他验证
		// 验证权限
		// let rules = window.sessionStorage.getItem('rules')
		// rules = rules ? JSON.parse(rules) : []

		// let index = rules.findIndex(item=>{
		// 	return  item.rule_id > 0 && item.desc === to.name
		// })
		// if(index === -1){
		// 	Vue.prototype.$message.error('你没有权限')
		// 	return next({name:from.name ? from.name : '/'})
		// }

		next();
	} else {
		// 跳过登录页验证
		if (to.path === '/login') {
			return next();
		}
		// 未登录
		// Vue.prototype.$message.error('请先登录');
		next({ path: '/login' })
	}
})

export default router
